module.exports = __webpack_public_path__ + "img/13.45a934ea.png";